import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { downloadDocument } from '@roc/feature-utils';

const dpiConstant = 0.264583;

const A4 = { width: 446.46, height: 631.4175 };

const addIgnoreToTags = (ignoreTagsIds) => {
  ignoreTagsIds.forEach(function (value) {
    const columnTag = document.getElementById(value);
    columnTag.setAttribute('data-html2canvas-ignore', 'true');
  })
};

const clearIgnoreTagsList = (ignoreTagsIds) => {
  ignoreTagsIds.forEach(function (value) {
    const columnTag = document.getElementById(value);
    columnTag.removeAttribute('data-html2canvas-ignore');
  })
};

const afterConvertToCanvas = (canvasList, fileName) => {
  const pdf = new jsPDF(null, 'mm', 'a4');
  pdf.deletePage(1);

  for (let i = 0; i < canvasList.length; i++) {
    const canvas = canvasList[i];
    const width = canvas.width;
    const height = canvas.height;
    const millimeters = { width: 0, height: 0 };
    millimeters.width = Math.floor(width * dpiConstant);
    millimeters.height = Math.floor(height * dpiConstant);

    pdf.addPage([millimeters.width, millimeters.height], width < height ? 'p' : 'l');

    const imgData = canvas.toDataURL('image/jpeg');
    pdf.addImage(imgData, 'JPEG', 0, 0, millimeters.width, millimeters.height, undefined, 'FAST');
  };
  return pdf;
};

const afterConvertToCanvasV2 = (canvasList, fileName) => {
  let jspdf = new jsPDF();

  for (let i = 0; i < canvasList.length; i++) {
    const canvas = canvasList[i];
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;

    jspdf = new jsPDF('portrait', 'px', [A4.width, A4.height]);

    const imgData = canvas.toDataURL('image/jpeg');

    const widthRatio = A4.width / canvasWidth;
    const heightRatio = A4.height / canvasHeight;
    const ratio = Math.min(widthRatio, heightRatio);

    const imgWidth = canvasWidth * ratio;
    const imgHeight = canvasHeight * ratio;

    jspdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
  }

  return jspdf;
};

export const multiPageScreenshotGrid = (fileName: string, screenshotsIds: string[], ignoreTagsIds: string[]) => {

  const downloadPdf = async () => {
    addIgnoreToTags(ignoreTagsIds);
    let listOfCanvas = []
    for (const htmlTag of screenshotsIds) {
      const canvas = await html2canvas(document.getElementById(htmlTag), {
        scrollX: 0,
        scrollY: 0,
        useCORS: true,
      });
      listOfCanvas.push(canvas);
    };
    const pdf = afterConvertToCanvas(listOfCanvas, fileName);
    pdf.save(fileName);
    clearIgnoreTagsList(ignoreTagsIds);
  };

  downloadPdf();
};

const getFormData = (pdf, fileName) => {
  const pdfBlob = pdf.output('blob');
  const newFile = new File([pdfBlob], `${fileName}.pdf`, { type: 'pdf' });
  const formData = new FormData();
  formData.append('file', newFile);
  return formData;
}

export const getMultiPageScreenshotGrid = (fileName: string, screenshotsIds: string[], ignoreTagsIds: string[]) => {

  const getPdf = async () => {
    addIgnoreToTags(ignoreTagsIds);
    let listOfCanvas = []
    for (const htmlTag of screenshotsIds) {
      try {
        const canvas = await html2canvas(document.getElementById(htmlTag), {
          scrollX: 0,
          scrollY: 0,
          useCORS: true,
        });

        listOfCanvas.push(canvas);
      } catch (error) {
      }
    };

    const pdf = afterConvertToCanvas(listOfCanvas, fileName);
    clearIgnoreTagsList(ignoreTagsIds);

    return getFormData(pdf, fileName);
  };

  return getPdf();
}

export const getMultiPageScreenshotGridWaitingForImages = async (fileName: string, screenshotsIds: string[], ignoreTagsIds: string[]) => {

  addIgnoreToTags(ignoreTagsIds);
  let listOfCanvas = [];

  for (const htmlTag of screenshotsIds) {
    try {
      const container = document.getElementById(htmlTag);
      if (!container) continue;

      await waitForImagesToLoad(container);

      const canvas = await html2canvas(container, {
        scrollX: 0,
        scrollY: 0,
        useCORS: true,
      });

      listOfCanvas.push(canvas);

    } catch (error) {
      console.error(`Error capturando ${htmlTag}:`, error);
    }
  }

  const pdf = afterConvertToCanvasV2(listOfCanvas, fileName);
  clearIgnoreTagsList(ignoreTagsIds);

  return getFormData(pdf, fileName);
};

function waitForImagesToLoad(container: HTMLElement) {
  const images = container.querySelectorAll("img");
  const promises = Array.from(images).map((img) => {
    if (img.complete) return Promise.resolve();
    return new Promise((resolve) => {
      img.onload = img.onerror = resolve;
    });
  });
  return Promise.all(promises);
}

export default multiPageScreenshotGrid;